<template>
    <div ref="editor"></div>
</template>

<script>
    import E from 'wangeditor'
    export default {
        name: 'WEditorIndex',
        props: {
            value: {
                type: String,
                default: ''
            },
            meanArray: {
                // 自定义菜单
                type: Array,
                default: null
            }
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        watch: {
            value: function (value) {
                if (value !== this.editor.txt.html()) {
                    this.editor.txt.html(this.value)
                }
            }
        },
        data () {
            return {
                // 默认有这么多菜单，meanArray有值以meanArray为准
                defaultMeanus: [
                    'head',
                    'bold',
                    'fontSize',
                    'fontName',
                    'italic',
                    'underline',
                    'strikeThrough',
                    'indent',
                    'lineHeight',
                    'foreColor',
                    'backColor',
                    'link',
                    'list',
                    'justify',
                    'quote',
                    'emoticon',
                    'image',
                    'video',
                    'table',
                    'code',
                    'splitLine',
                    'undo',
                    'redo'
                ],
                editor: ''
            }
        },
        methods: {
            init () {
                const _this = this
                this.editor = new E(this.$refs.editor)
                this.editor.config.uploadImgShowBase64 = true
                this.setMenus()
                this.editor.config.onchange = (html) => {
                    _this.$emit('change', html)
                }
                this.editor.create()
            },
            setMenus () {
                // 设置菜单
                if (this.meanArray) {
                    this.editor.config.menus = this.meanArray
                } else {
                    this.editor.config.menus = this.defaultMeanus
                }
            },
            getHtml () {
                // 得到文本内容
                return this.editor.txt.html()
            },
            sethHtml (txt) {
                // 设置富文本里面的值
                this.editor.txt.html(txt)
            }
        },
        mounted () {
            let that = this
            that.$nextTick(function () {
                that.init()
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ui/WEditorIndex.vue